const seasons = JSON.parse(GLOBAL_SCRIPTS.SEASON_CYCLE.replace(/&quot;/g, '"'));

export const getSeason = (date) => {
  const season = Object.entries(seasons).find(([_, { begin, end }]) => date >= begin && date <= end);
  return season ? season[0] : 'SUMMER';
};